'use strict';/* global define */define('modules/users/services/performers/index',['require','exports','module'],function(require,exports,module){'use strict';function factory($resource,API_ENDPOINT){// jshint validthis:true
// jshint latedef:false
var base=API_ENDPOINT+'key-performers/:id';var Performers=$resource(base,{id:'@id'},{get:{isArray:true}});return{getPerformers:getPerformers,addPerformer:addPerformer,removePerformer:removePerformer};// ---
/**
     * Get key performers
     *
     * @param  {Object|undefined} params - optional request parameters
     *
     * @return {Object}                  - key performers
     */function getPerformers(params){var list=Performers.get(params);list.$type='key-performers';return list;}/**
     * Add performer
     *
     * @param {Object|undefined} params - optional request parameters
     */function addPerformer(params){return Performers.save(params);}/**
     * Remove performer
     *
     * @param {Object|undefined} params - optional request parameters
     */function removePerformer(params){return Performers.delete(params);}}module.exports=factory;});
